import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

function Dropdown({
  invert,
  full,
  large,
  placeholder,
  title,
  options,
  onChange,
  value
}) {
  return (
    <label
      className={classnames(
        'Dropdown', {
          'Dropdown--invert': invert,
          'Dropdown--large': large,
          'Dropdown--full': full
        }
      )}
      data-title={title}
    >
      <select
        onChange={onChange}
        value={value}
      >
        <option
          disabled
          value=""
        >{placeholder}</option>
        {
          options.map((o, i) => (
            <option
              key={i}
              value={o.value}
            >{o.text}</option>
          ))
        }
      </select>
    </label>
  );
}

Dropdown.propTypes = {
  invert: PropTypes.bool,
  full: PropTypes.bool,
  large: PropTypes.bool,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  options: PropTypes.array,
  onChange: PropTypes.func
};

Dropdown.defaultProps = {
  invert: false,
  full: false,
  title: false,
  large: false,
  value: '',
  placeholder: 'Select...',
  options: [],
  onChange: () => false
};

export default Dropdown;


// WEBPACK FOOTER //
// ./src/components/Dropdown.js